export function getTour(data: boolean) {
  return { type: "GET_TOUR", data } as const;
}
